<script>
import FormStepBase from '../../components/FormStepBase.vue'

export default {
  extends: FormStepBase,
  name: 'FormStep1'
}
</script>
